module.exports = __webpack_public_path__ + "img/refused_active.55262aa8.png";